module.exports = __webpack_public_path__ + "static/media/4.4311cc9b.jpeg";